import React, { useEffect, useState } from 'react';
import {
  Breadcrumb,
  Button,
  CheckPicker,
  Container,
  Divider,
  IconButton,
  Input,
  InputGroup,
  InputNumber,
  Message,
  Pagination,
  Panel,
  SelectPicker,
  Stack,
  Table,
  Tooltip,
  Whisper,
  useToaster
} from 'rsuite';
import SearchIcon from '@rsuite/icons/Search';
import globalIP from '@/GlobelIP';
import { useLocation, useNavigate } from 'react-router-dom';
import { Icon } from '@rsuite/icons';
import TrashIcon from '@rsuite/icons/Trash';
import SendIcon from '@rsuite/icons/Send';
import EditIcon from '@rsuite/icons/Edit';
import CloseOutlineIcon from '@rsuite/icons/CloseOutline';
import ugr from '@/UGRoute';

interface RowData {
  id: string; // or number, depending on your data
  attributes: {
    CategoryCode: string;
    ProductTypeCode: string;
    ProductCode: string;
    ProductId: string;
    ProductName: string;
    Description: string;
    SizeUnit: string;
    Length: 0;
    Width: 0;
    Height: 0;
    FinishCode: null;
    ColorCode: null;
    NetWeight: 0;
    GrossWeight: 0;
    HSNCode: string;
    SellingPriceCurrency: string;
    SellingPriceUnit: string;
    SellingPrice: 0;
    ProductCost: 0;
    SearchKeyword: string;
    MOQ: string;
    ProductDesigner: null;
    MadeBy: null;
    CategoryName: string;
    ProductTypeName: null;
    cbm: null;
    FinishName: null;
    ColorName: null;
    BuyerName: null;
    BuyerSku: null;
    SizeRange: null;
    Total_CBM: null;
    Total_CFT: null;
    TwentyFT: null;
    FortyFT: null;
    FortyHQ: null;
    Product_Remark: string;
    Shape: string;
    Season: string;
    P_Technique: string;
    CoverImage: {
      data: {
        attributes: {
          url: string;
          // Add other properties of CoverImage if needed
        };
      };
    };
    MultipleImage: {
      data: {
        attributes: {
          url: string;
          // Add other properties of CoverImage if needed
        };
      };
    };
    ProductionDetail: [
      {
        id: string;
        ProductCode: string;
        MaterialNm: string;
        MaterialFinishNm: string;
        MatNetWeight: 0;
        MaterialCode: string;
        MaterialFinishCode: string;
      }
    ];
  };
}

const ModifyonTable = () => {
  const ip = globalIP;
  const location = useLocation();
  const toaster = useToaster();
  const searchParams = new URLSearchParams(location.search);
  const selectedItems = searchParams.get('selectedItems') || '';
  const selectedItemsArray = selectedItems.split(',');
  const [data123, setData123] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    const productvarid = selectedItemsArray.map(id => `filters[id][$in]=${id}`).join('&');
    setLoading(true);
    const response = await fetch(
      `${ip}/api/products?${productvarid}&populate=*&pagination[page]=1`
    );
    const json = await response.json();
    const allSelectedItems = [];
    for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${ip}/api/products?${productvarid}&populate=*&pagination[page]=${page}`
      );
      const pageJson = await pageResponse.json();
      allSelectedItems.push(...pageJson.data);
    }
    const responsevar = await fetch(`${ip}/api/variant-products?${productvarid}&populate=*`);
    const jsonvar = await responsevar.json();
    const newData1234 = [...allSelectedItems, ...jsonvar.data];
    setData123(newData1234);
    setLoading(false);
  };

  const [currentPage, setCurrentPage] = useState(1);
  const dataWithSerialNumbers = data123
    .slice()
    .reverse()
    .map((item, index) => ({
      ...item,
      serialNumber: index + 1
    }));
  const paginatedData = dataWithSerialNumbers.slice((currentPage - 1) * 10, currentPage * 10);
  const { Column, HeaderCell, Cell } = Table;
  const [label, setLabel] = useState([]);
  useEffect(() => {
    fetchDatalabel();
  }, []);
  const fetchDatalabel = async () => {
    try {
      const response = await fetch(`${ip}/api/product-labels`);
      const json = await response.json();
      setLabel(json.data);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const [editedRowIds, setEditedRowIds] = useState<string[]>([]);
  const [editedData, setEditedData] = useState<Record<string, Partial<RowData['attributes']>>>({});
  const handleEditRow = id => {
    setEditedRowIds(prevRowIds => [...prevRowIds, id]);
    setEditedData(prevData => ({
      ...prevData,
      [id]: { ...data123.find(item => item.id === id).attributes }
    }));
    setShowIcon(!showIcon);
  };
  useEffect(() => {
    if (data123) {
      data123.forEach(item => handleEditRow(item.id));
    }
  }, [data123]);
  const [sizeshow, setSizeShow] = useState(false);
  useEffect(() => {
    fetchDatacompany();
  }, []);
  const fetchDatacompany = async () => {
    try {
      const response = await fetch(`${ip}/api/company-details`);
      const json = await response.json();
      const extractedData = json.data[0].attributes.FreeSize;
      setSizeShow(extractedData);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const [finishdata, setFinishdata] = useState([]);
  const [isLoadingfin, setIsLoadingfin] = useState(false);
  useEffect(() => {
    fetchData4();
  }, []);
  const fetchData4 = async () => {
    if (isLoadingfin) {
      return;
    }
    setIsLoadingfin(true);
    try {
      const response = await fetch(
        `${ip}/api/mstfinishes?&pagination[page]=1&filters[dis][$ne]=Discontinue`
      );
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${ip}/api/mstfinishes?&pagination[page]=${page}&filters[dis][$ne]=Discontinue`
        );
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.FinishName,
          value: item.attributes.FinishCode
        }));
        allData.push(...processedData);
      }
      setFinishdata(allData);
      setIsLoadingfin(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const [colordata, setColordata] = React.useState([]);
  const [isLoadingcolor, setIsLoadingcolor] = React.useState(false);
  useEffect(() => {
    fetchData5();
  }, []);
  const fetchData5 = async () => {
    if (isLoadingcolor) {
      return;
    }
    setIsLoadingcolor(true);
    try {
      const response = await fetch(
        `${ip}/api/mstcolors?&pagination[page]=1&filters[dis][$ne]=Discontinue`
      );
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${ip}/api/mstcolors?&pagination[page]=${page}&filters[dis][$ne]=Discontinue`
        );
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.ColorName,
          value: item.attributes.ColorCode
        }));
        allData.push(...processedData);
      }
      setColordata(allData);
      setIsLoadingcolor(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const [matdata, setMatdata] = React.useState([]);
  const [isLoadingmat, setIsLoadingmat] = React.useState(false);
  useEffect(() => {
    fetchData6();
  }, []);
  const fetchData6 = async () => {
    if (isLoadingmat) {
      return;
    }
    setIsLoadingmat(true);
    try {
      const response = await fetch(
        `${ip}/api/mstmaterials?&pagination[page]=1&filters[dis][$ne]=Discontinue&filters[Type][$eq]=mrmaterial&filters[Type][$eq]=cmaterial&filters[Type][$eq]=wmaterial&sort[0]=MaterialName`
      );
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${ip}/api/mstmaterials?&pagination[page]=${page}&filters[dis][$ne]=Discontinue&filters[Type][$eq]=mrmaterial&filters[Type][$eq]=cmaterial&filters[Type][$eq]=wmaterial&sort[0]=MaterialName`
        );
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.MaterialName,
          value: item.attributes.MaterialCode
        }));
        allData.push(...processedData);
      }
      setMatdata(allData);
      setIsLoadingmat(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const [categorydata, setCategorydata] = useState([]);
  const [isLoadingc, setIsLoadingc] = useState(false);
  useEffect(() => {
    fetchDatacat();
  }, []);
  const fetchDatacat = async () => {
    if (isLoadingc) {
      return;
    }
    setIsLoadingc(true);
    try {
      const response = await fetch(
        `${ip}/api/mstcategories?&pagination[page]=1&filters[dis][$ne]=Discontinue`
      );
      const json = await response.json();
      const allData = [];

      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${ip}/api/mstcategories?&pagination[page]=${page}&filters[dis][$ne]=Discontinue`
        );
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.CategoryName,
          value: item.attributes.CategoryCode
        }));
        allData.push(...processedData);
      }
      setCategorydata(allData);
      setIsLoadingc(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const [productypedata, setProductypedata] = useState([]);
  const [isLoadingpro, setIsLoadingpro] = useState(false);
  useEffect(() => {
    fetchData2();
  }, []);
  const fetchData2 = async () => {
    if (isLoadingpro) {
      return;
    }
    setIsLoadingpro(true);
    try {
      const response = await fetch(`${ip}/api/mstproducttypes?&pagination[page]=1`);
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(`${ip}/api/mstproducttypes?&pagination[page]=${page}`);
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.ProductTypeName,
          value: item.attributes.ProductTypeCode,
          category: item.attributes.Categorycode   // <-- important
        }));

        allData.push(...processedData);
      }
      setProductypedata(allData);
      setIsLoadingpro(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const [currencydata, setCurrencydata] = useState([]);
  const [isLoadingCurr, setIsLoadingCurr] = useState(false);
  useEffect(() => {
    fetchDataCur();
  }, []);
  const fetchDataCur = async () => {
    if (isLoadingCurr) {
      return;
    }
    setIsLoadingCurr(true);
    try {
      const response = await fetch(`${ip}/api/currency-masters?&pagination[page]=1`);
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(`${ip}/api/currency-masters?&pagination[page]=${page}`);
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.currencyname,
          value: item.attributes.currencyname
        }));
        allData.push(...processedData);
      }
      setCurrencydata(allData);
      setIsLoadingCurr(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const handleInputChange3 = (rowId, fieldName, codeFieldName, value, data) => {
    setEditedData(prevData => {
      const updatedData = { ...prevData };
      if (!updatedData[rowId]) {
        updatedData[rowId] = {
          ProductName: '',
          Description: '',
          NetWeight: 0,
          GrossWeight: 0,
          Product_Remark: ''
        };
      }
      const selectedData = data.find(item => item.label === value);
      updatedData[rowId][fieldName] = value;
      updatedData[rowId][codeFieldName] = selectedData ? selectedData.value : ''; // Set Code based on selected Name
      return updatedData;
    });
  };
  const handleInputChange2 = (rowId, fieldName, value) => {
    setEditedData(prevData => {
      const updatedData = { ...prevData };
      if (!updatedData[rowId]) {
        updatedData[rowId] = {
          ProductName: '',
          Description: '',
          NetWeight: 0,
          GrossWeight: 0,
          Product_Remark: ''
        };
      }
      updatedData[rowId][fieldName] = value;
      return updatedData;
    });
  };
  const [showIcon, setShowIcon] = useState(false);
  const handleToggleIcon = () => {
    setShowIcon(!showIcon);
  };
  const handleDeleteRow = id => {
    setData123(prevData => prevData.filter(item => item.id !== id));
  };
  const handleMaterialChange = (rowId, materialNames, materialCodes) => {
    setEditedData(prev => ({
      ...prev,
      [rowId]: {
        ...prev[rowId],
        ProductionDetail: materialNames.map((name, index) => ({
          ProductCode: prev[rowId]?.ProductCode || '', // default/fallback
          MaterialNm: name,
          MaterialCode: materialCodes[index]
        }))
      }
    }));
  };

  const defaultColumns = [
    {
      key: 'serialNumber',
      label: <b>Sr.No.</b>,
      fixed: true,
      width: 50
    },
    {
      key: 'Image',
      label: 'Image',
      width: 80,
      align: 'center',
      headerCell: (
        <Table.HeaderCell>
          <b>Image</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Table.Cell>
          {rowData => {
            // Define a function to show the enlarged image on hover
            const renderTooltip = imageSrc => (
              <Tooltip style={{ backgroundColor: 'white' }}>
                <img src={imageSrc} alt="Product Image" style={{ width: 400, height: 'auto' }} />
              </Tooltip>
            );
            return (
              <Whisper
                followCursor
                trigger="hover"
                placement="right"
                speaker={renderTooltip(`${ip}${rowData?.attributes?.CoverImage?.data?.attributes?.url}`)}
              >
                <img
                  src={`${ip}${rowData?.attributes?.CoverImage?.data?.attributes?.url}`}
                  alt="Product Image"
                  style={{ width: 50, height: 50, marginTop: '-16px' }}
                />
              </Whisper>
            );
          }}
        </Table.Cell>
      )
    },
    {
      key: 'CategoryName',
      label: `${label[0]?.attributes.Category}`,
      width: 150,
      align: 'center',
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.Category}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData =>
            editedRowIds.includes(rowData.id) ? (
              <SelectPicker
                data={categorydata}
                labelKey="label"
                valueKey="label"
                value={editedData[rowData.id]?.CategoryName || ''}
                onChange={value =>
                  handleInputChange3(
                    rowData.id,
                    'CategoryName',
                    'CategoryCode',
                    value,
                    categorydata
                  )
                }
              />
            ) : (
              rowData.attributes.CategoryName
            )
          }
        </Cell>
      )
    },
    {
      key: 'ProducttypeName',
      label: `${label[0]?.attributes.ProductType}`,
      width: 150,
      align: 'center',
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.ProductType}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData =>
            editedRowIds.includes(rowData.id) ? (
              <SelectPicker
                data={
                  productypedata.filter(
                    p => p.category === editedData[rowData.id]?.CategoryCode
                  )
                }
                 labelKey="label"
                valueKey="label"
                value={editedData[rowData.id]?.ProductTypeName || ''}
                onChange={value =>
                  handleInputChange3(
                    rowData.id,
                    'ProductTypeName',
                    'ProductTypeCode',
                    value,
                    productypedata
                  )
                }
              />
            ) : (
              rowData.attributes.ProductTypeName
            )
          }
        </Cell>
      )
    },
    {
      key: 'ProductId',
      label: `${label[0]?.attributes.AliasCode}`,
      width: 100,
      align: 'center',
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.AliasCode}</b>
        </Table.HeaderCell>
      ),
      cell: <Table.Cell dataKey="attributes.ProductId" />
    },
    {
      key: 'ProductName',
      label: `${label[0]?.attributes.ProductName}`,
      width: 150,
      align: 'center',
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.ProductName}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData =>
            editedRowIds.includes(rowData.id) ? (
              <Input
                value={editedData[rowData.id]?.ProductName || ''}
                onChange={value => handleInputChange2(rowData.id, 'ProductName', value)}
              />
            ) : (
              rowData.attributes.ProductName
            )
          }
        </Cell>
      )
    },
    {
      key: 'Description',
      label: `${label[0]?.attributes.Description}`,
      width: 200,
      align: 'center',
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.Description}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData =>
            editedRowIds.includes(rowData.id) ? (
              <Input
                value={editedData[rowData.id]?.Description || ''}
                onChange={value => handleInputChange2(rowData.id, 'Description', value)}
              />
            ) : (
              rowData.attributes.Description
            )
          }
        </Cell>
      )
    },
    {
      key: sizeshow ? 'SizeRange' : 'Dimension',
      label: sizeshow ? `${label[0]?.attributes.SizeRange}` : 'Dimension',
      width: 200,
      headerCell: (
        <Table.HeaderCell flexGrow={1}>
          <b>{sizeshow ? label[0]?.attributes.SizeRange : 'Dimension'}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData =>
            sizeshow ? (
              editedRowIds.includes(rowData.id) ? (
                <Input
                  value={editedData[rowData.id]?.SizeRange || ''}
                  onChange={value => handleInputChange2(rowData.id, 'SizeRange', value)}
                />
              ) : (
                rowData.attributes.SizeRange
              )
            ) : (
              `${rowData.attributes.Length} x ${rowData.attributes.Width} x ${rowData.attributes.Height} ${rowData.attributes.SizeUnit}`
            )
          }
        </Cell>
      )
    },

    // {
    //   key: 'SizeRange',
    //   label: `${label[0]?.attributes.SizeRange}`,
    //   width: 80,
    //   align: 'center',
    //   headerCell: <Table.HeaderCell><b>{label[0]?.attributes.SizeRange}</b></Table.HeaderCell>,
    //   cell: <Cell>
    //     {(rowData) => (
    //       editedRowIds.includes(rowData.id) ? (
    //         <Input
    //           value={editedData[rowData.id]?.SizeRange || ''}
    //           onChange={(value) => handleInputChange2(rowData.id, 'SizeRange', value)}
    //         />
    //       ) : (
    //         rowData.attributes.SizeRange
    //       )
    //     )}
    //   </Cell>
    // },

    {
      key: 'FinishName',
      label: `${label[0]?.attributes.finish}`,
      width: 150,
      align: 'center',
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.finish}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData =>
            editedRowIds.includes(rowData.id) ? (
              <SelectPicker
                data={finishdata}
                labelKey="label"
                valueKey="label"
                value={editedData[rowData.id]?.FinishName || ''}
                onChange={value =>
                  handleInputChange3(rowData.id, 'FinishName', 'FinishCode', value, finishdata)
                }
              />
            ) : (
              rowData.attributes.FinishName
            )
          }
        </Cell>
      )
    },
    {
      key: 'ColorName',
      label: `${label[0]?.attributes.color}`,
      width: 150,
      align: 'center',
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.color}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData =>
            editedRowIds.includes(rowData.id) ? (
              <SelectPicker
                data={colordata}
                labelKey="label"
                valueKey="label"
                value={editedData[rowData.id]?.ColorName || ''}
                onChange={value =>
                  handleInputChange3(rowData.id, 'ColorName', 'ColorCode', value, colordata)
                }
              />
            ) : (
              rowData.attributes.ColorName
            )
          }
        </Cell>
      )
    },
    {
      key: 'MaterialNm',
      label: 'Material',
      width: 200,
      align: 'center',
      headerCell: (
        <Table.HeaderCell>
          <b>Material</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData =>
            editedRowIds.includes(rowData.id) ? (
              <CheckPicker
                data={matdata}
                labelKey="label"
                valueKey="label"
                value={editedData[rowData.id]?.ProductionDetail?.map(detail => detail.MaterialNm) || []}
                onChange={(selectedLabels) => {
                  console.log("Selected materials:", selectedLabels); // ✅ check this
                  const selectedItems = matdata.filter(item => selectedLabels.includes(item.label));
                  const selectedCodes = selectedItems.map(item => item.value);
                  handleMaterialChange(rowData.id, selectedLabels, selectedCodes);
                }}
                style={{ width: '100%' }}
              />
            ) : (
              rowData.attributes.ProductionDetail?.map((mat, idx) => (
                <div key={idx}>{mat.MaterialNm}</div>
              ))
            )
          }
        </Cell>
      )
    },

    {
      key: 'NetWt',
      label: `${label[0]?.attributes.NetWgt}`,
      width: 100,
      align: 'center',
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.NetWgt}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData =>
            editedRowIds.includes(rowData.id) ? (
              <InputNumber
                step={0}
                value={editedData[rowData.id]?.NetWeight || ''}
                onChange={value => handleInputChange2(rowData.id, 'NetWeight', value)}
              />
            ) : (
              rowData.attributes.NetWeight
            )
          }
        </Cell>
      )
    },
    {
      key: 'GrossWt',
      label: `${label[0]?.attributes.GrossWgt}`,
      width: 100,
      align: 'center',
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.GrossWgt}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData =>
            editedRowIds.includes(rowData.id) ? (
              <InputNumber
                step={0}
                value={editedData[rowData.id]?.GrossWeight || ''}
                onChange={value => handleInputChange2(rowData.id, 'GrossWeight', value)}
              />
            ) : (
              rowData.attributes.GrossWeight
            )
          }
        </Cell>
      )
    },
    {
      key: 'Currency',
      label: `${label[0]?.attributes.Currency}`,
      width: 100,
      align: 'center',
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.Currency}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData =>
            editedRowIds.includes(rowData.id) ? (
              <SelectPicker
                data={currencydata}
                labelKey="label"
                valueKey="label"
                value={editedData[rowData.id]?.SellingPriceCurrency || ''}
                onChange={value => handleInputChange2(rowData.id, 'SellingPriceCurrency', value)}
              />
            ) : (
              rowData.attributes.SellingPriceCurrency
            )
          }
        </Cell>
      )
    },
    {
      key: 'ProductCost',
      label: `${label[0]?.attributes.SalePriceINR}`,
      width: 100,
      align: 'center',
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.SalePriceINR}</b>
        </Table.HeaderCell>
      ),
      cell: <Table.Cell dataKey="attributes.ProductCost" />
    },
    {
      key: 'ProductR',
      label: `${label[0]?.attributes.ProductRemark}`,
      width: 100,
      align: 'center',
      headerCell: (
        <Table.HeaderCell>
          <b>{label[0]?.attributes.ProductRemark}</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Cell>
          {rowData =>
            editedRowIds.includes(rowData.id) ? (
              <Input
                value={editedData[rowData.id]?.Product_Remark || ''}
                onChange={value => handleInputChange2(rowData.id, 'Product_Remark', value)}
              />
            ) : (
              rowData.attributes.Product_Remark
            )
          }
        </Cell>
      )
    },
    {
      key: 'cbm',
      label: `${label[0]?.attributes.cbm}`,
      width: 100,
      align: 'center',
      headerCell: <Table.HeaderCell>{label[0]?.attributes.cbm}</Table.HeaderCell>,
      cell: (
        <Table.Cell dataKey="attributes.Total_CBM">
          {rowData => <div>{rowData.attributes.Total_CBM}</div>}
        </Table.Cell>
      )
    },

    {
      key: 'Action',
      label: 'Action',
      width: 100,
      align: 'center',
      headerCell: (
        <Table.HeaderCell>
          <b>Action</b>
        </Table.HeaderCell>
      ),
      cell: (
        <Table.Cell style={{ padding: '6px' }}>
          {rowData => (
            <IconButton
              size="sm"
              icon={<TrashIcon />}
              active
              onClick={() => handleDeleteRow(rowData.id)}
            />
          )}
        </Table.Cell>
      )
    }
  ];
  const CompactCell = props => <Cell {...props} style={{ padding: 4 }} />;
  const CompactHeaderCell = props => <HeaderCell {...props} style={{ padding: 4 }} />;
  const [compact, setCompact] = useState(true);
  const [columnKeys, setColumnKeys] = useState(
    defaultColumns
      .map(column => column.key)
      .filter(key => key !== 'ProductCost' && key !== 'Currency')
  );
  const CustomCell = compact ? CompactCell : Cell;
  const CustomHeaderCell = compact ? CompactHeaderCell : HeaderCell;
  const [loading1, setLoading1] = useState(false);
  const moved = useNavigate();
  const save = async () => {
    try {
      setLoading1(true);
      for (const productId of selectedItemsArray) {
        const editedAttributes = editedData[productId]; // Get edited attributes for the current product
        if (editedAttributes) {
          const formData = new FormData();
          delete editedAttributes.CoverImage;
          delete editedAttributes.MultipleImage;
          formData.append('data', JSON.stringify(editedAttributes));
          const response = await fetch(`${ip}/api/products/${productId}`, {
            method: 'PUT',
            body: formData
          });
          if (response.ok) {
            console.log(`Product with ID ${productId} updated successfully.`);
          } else {
            console.error(`Failed to update product with ID ${productId}.`);
          }
        } else {
          console.error(`No edited attributes found for product with ID ${productId}.`);
        }
      }
      setLoading1(false);
      toaster.push(
        <Message showIcon type="success">
          {selectedItemsArray.length} Products Update Successfully
        </Message>,
        { placement: 'topEnd' }
      );
      moved(`/${ugr}/manageProduct`);
    } catch (error) {
      console.error('Error updating products:', error);
    }
  };

  const [tableHeight, setTableHeight] = useState(20); // Default height
  useEffect(() => {
    const calculateHeight = () => {
      const headerHeight = 260; // Adjust based on your header/footer size
      const footerHeight = 5; // Adjust based on your footer size
      const availableHeight = window.innerHeight - headerHeight - footerHeight;
      setTableHeight(availableHeight);
    };
    calculateHeight();
    window.addEventListener('resize', calculateHeight); // Recalculate on window resize
    return () => window.removeEventListener('resize', calculateHeight);
  }, []);
  return (
    <>
      <Container className="main">
        <Stack className="table-toolbar" justifyContent="space-between">
          <Stack direction="column" alignItems="flex-start">
            <Stack direction="column" alignItems="flex-start">
              <h3 className="title">Manage Product</h3>
              <Breadcrumb>
                <Breadcrumb.Item href={`/${ugr}/dashboard`}>Home</Breadcrumb.Item>
                <Breadcrumb.Item href={`/${ugr}/manageProduct`}>Manage Product</Breadcrumb.Item>
                <Breadcrumb.Item active>Modify on Table</Breadcrumb.Item>
              </Breadcrumb>
            </Stack>
          </Stack>
          <Stack alignItems="flex-end">
            <Button onClick={save} appearance="primary" color="cyan" loading={loading1}>
              Finish
            </Button>
          </Stack>
        </Stack>
        <Divider className="divide" />
        <div className="row">
          <Panel>
            <Table
              rowHeight={60}
              data={paginatedData}
              height={tableHeight}
              rowKey="id"
              loading={loading}
              bordered
              cellBordered
              wordWrap="break-word"
              headerHeight={50}
            >
              {defaultColumns.map(column => {
                if (columnKeys.includes(column.key)) {
                  const { key, label, headerCell, cell, ...rest } = column;
                  return (
                    <Table.Column {...rest} key={key}>
                      {headerCell || <CustomHeaderCell>{label}</CustomHeaderCell>}
                      {cell || <CustomCell dataKey={key} />}
                    </Table.Column>
                  );
                }
                return null;
              })}
            </Table>
            <Pagination
              prev
              next
              first
              last
              ellipsis
              boundaryLinks
              maxButtons={5}
              size="xs"
              layout={['total', '-', '|', 'pager', 'skip']}
              total={dataWithSerialNumbers.length}
              limit={10}
              activePage={currentPage}
              onChangePage={setCurrentPage}
              style={{ marginTop: '5px' }}
            />
          </Panel>
        </div>
        <Stack
          className="copyright"
          justifyContent="flex-end"
          spacing={5}
          style={{
            position: 'fixed',
            bottom: '0',
            width: '-webkit-fill-available',
            textAlign: 'center',
            backgroundColor: 'white',
            paddingRight: '16px'
          }}
        >
          <p>© All Right Reserved. Product by </p>
          <p>
            {' '}
            <a href="https://erpdaddy.com/" target="_blank">
              ERP Daddy Softwere Solution.
            </a>
          </p>
        </Stack>
      </Container>
    </>
  );
};
export default ModifyonTable;
